import { render, staticRenderFns } from "./BloquearPlazasRegionAnexa.vue?vue&type=template&id=56473a34&scoped=true"
import script from "./BloquearPlazasRegionAnexa.vue?vue&type=script&setup=true&lang=js"
export * from "./BloquearPlazasRegionAnexa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BloquearPlazasRegionAnexa.vue?vue&type=style&index=0&id=56473a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56473a34",
  null
  
)

export default component.exports